import { render, staticRenderFns } from "./addCardModel.vue?vue&type=template&id=037aac49&scoped=true"
import script from "./addCardModel.vue?vue&type=script&lang=js"
export * from "./addCardModel.vue?vue&type=script&lang=js"
import style0 from "./addCardModel.vue?vue&type=style&index=0&id=037aac49&prod&lang=scss&scoped=true"
import style1 from "./addCardModel.vue?vue&type=style&index=1&id=037aac49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037aac49",
  null
  
)

export default component.exports